import { render, staticRenderFns } from "./ClientThingsCatalogPage.vue?vue&type=template&id=bfdda650&scoped=true&"
import script from "./ClientThingsCatalogPage.vue?vue&type=script&lang=ts&"
export * from "./ClientThingsCatalogPage.vue?vue&type=script&lang=ts&"
import style0 from "./ClientThingsCatalogPage.vue?vue&type=style&index=0&id=bfdda650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdda650",
  null
  
)

export default component.exports